import { useState } from "react";
import { TAN_TABLE_CONSTS } from "./TanTable.consts";

interface usePaginationInput {
  initialSize?: number;
}
export function usePagination({
  initialSize = TAN_TABLE_CONSTS.initialPageSize,
}: usePaginationInput = {}) {
  const [pagination, setPagination] = useState({
    pageSize: initialSize,
    pageIndex: 0,
  });
  const { pageSize, pageIndex } = pagination;

  return {
    onPaginationChange: setPagination,
    pagination,
    limit: pageSize,
    skip: pageSize * pageIndex,
  };
}
